export function isUuid(val: string | undefined | null): val is string {
  if (!val) return false;
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(val);
}

export function jobColumnFor(val: string | undefined | null): 'id' | 'job_number' {
  return isUuid(val) ? 'id' : 'job_number';
}
